import React from "react";
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import { Link } from 'react-router-dom';
import { Trainings } from "../../../store/Utility/Utility";

const Training = () => {
  return (
    <>
      <HerosectionHeader folder1={"pages"} folder2={"Company"} name={"Training"} />
      <section>
        <div className="container">
          <div className="row align-items-end justify-content-between">
            <div className="col-12 col-lg-5">
              <div>
                <h2 className="mb-0"><span className="font-w-4 d-block">Boost inspections with our essential training!</span></h2>
              </div>
            </div>
            <div className="col-12 col-lg-6 mt-3 my-lg-0">
              <p className="lead mb-0">Please review each subject here to gain insight into successfully completing any inspection.</p>
            </div>
          </div>
          {/* <!-- / .row --> */}
          <div className="row">
            <div className="col">
              {Trainings && Trainings.map((item, index) =>
                <div key={index} className="card bg-transparent flex-md-row align-items-center p-md-0 p-3 mt-4">
                  <div className="card-body col-md-6">
                    <h2 className="h5 my-2">
                      <a className="link-title" href="blog-single.html">{item.description}</a>
                    </h2>
                  </div>
                  <div className="col-md-2">
                    <Link to={item.path} className="btn btn-primary">Read</Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Training;